import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';

import PageWrapper from '../ui/PageWrapper';
import { Paper, Grid } from '@material-ui/core';

import CartSmall from './CartSmall';
import CheckoutFlow from "./CheckoutFlow";

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: 12 * 2,
    color: theme.palette.text.secondary,
    marginBottom: "20px"
  },
  inputInfo: {
    fontSize: "16px",
    marginTop: "20px",
    color: "black"
  }
});

function Checkout(props) {
  const { classes, config, item } = props;
  const [cartItem, setCartItem] = useState();

  useEffect(() => {
    if (!item.price_id) return;

    fetch(`/price-info/${item.price_id}`)
      .then(res => res.json())
      .then(product => {
        setCartItem(product)
      }).catch(error => console.error('Error:', error));

  }, [item]);

  return (
    <PageWrapper>
      <Grid container className={classes.root} spacing={2} direction={'row-reverse'}>
        <Grid item md={4} xs={12}>
          <Paper className={classes.paper}>
            <CartSmall
              item={cartItem}
              config={config}
            />
          </Paper>
        </Grid>
        <Grid item md={8} xs={12}>
          <CheckoutFlow
            classes={classes}
            priceID={item.price_id}
          />
        </Grid>
      </Grid>
    </PageWrapper>
  );
}
export default withStyles(styles)(Checkout);